import ApiService from '@/services/api.service';

const getLocations = () => {
    const params = {};
    // const sql = "SELECT * from oil_locations where type = 'state'";
    const sql = "SELECT * from oil_locations where  (type = 'state' AND production_percent IS NOT NULL) OR (type != 'state')";
    params.sql = window.btoa(sql);
    params.pre = 1;
    params.totalItems = 10000;
    params.rowsPerPage = 10000;
    return ApiService.query('/datasource/sql/' + 979, { params })
  }

  const getOperators = () => {
    const params = {};
    const sql = "SELECT id, code, name from oil_operators";
    params.sql = window.btoa(sql);
    params.pre = 1;
    params.totalItems = 10000;
    params.rowsPerPage = 10000;
    return ApiService.query('/datasource/sql/' + 979, { params })
  }

  

  export {
    getLocations,
    getOperators,
  }